import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { FormFieldContext } from "./FormFieldContext.js";
/* empty css              */
import { useId, useMemo } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/FormField/FormField.tsx
var hasContent = (node) => node !== void 0 && node !== null && node !== false;
/**
* A label, a control, and help or an error under it. The label, hint and error are
* associated with the control through context, so Payments Console controls need no
* extra props; other controls use `useFormFieldControl()`.
*/
function FormField({ label, htmlFor, required = false, hint, error, children, className }) {
	const generatedId = useId();
	const id = htmlFor ?? `ds-field-${generatedId}`;
	const invalid = hasContent(error);
	const messageId = invalid ? `${id}-error` : hasContent(hint) ? `${id}-hint` : void 0;
	const context = useMemo(() => ({
		id,
		describedBy: messageId,
		invalid
	}), [
		id,
		messageId,
		invalid
	]);
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-form-field", className),
		children: [
			hasContent(label) && /* @__PURE__ */ jsxs("label", {
				className: "ds-form-field__label",
				htmlFor: id,
				children: [label, required && /* @__PURE__ */ jsxs(Fragment$1, { children: [" ", /* @__PURE__ */ jsx("span", {
					className: "ds-form-field__required",
					children: "(required)"
				})] })]
			}),
			/* @__PURE__ */ jsx(FormFieldContext.Provider, {
				value: context,
				children
			}),
			invalid ? /* @__PURE__ */ jsxs("p", {
				id: messageId,
				className: "ds-form-field__error",
				children: [/* @__PURE__ */ jsx("span", {
					className: "ds-form-field__error-icon",
					"aria-hidden": "true",
					children: /* @__PURE__ */ jsx(Icon, { name: "alert-circle" })
				}), /* @__PURE__ */ jsx("span", { children: error })]
			}) : hasContent(hint) && /* @__PURE__ */ jsx("p", {
				id: messageId,
				className: "ds-form-field__hint",
				children: hint
			})
		]
	});
}
//#endregion
export { FormField };

//# sourceMappingURL=FormField.js.map